import { A4uCode as IconComponent } from '@adobe/react-spectrum-workflow/dist/Code.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function Code(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}